import "./styles/ScreenShotsSection.css";
import demofoto1 from "../assets/demoFoto1.PNG";
import demofoto4 from "../assets/demoFoto4.PNG";
import SafeBite1 from "../assets/SafeBite1.png";
import SafeBite2 from "../assets/SafeBite2.png";

function ScreenshotsSection() {
  return (
    <div className="ScreenshotContainer">
      <div className="screenshotContent">
        <h1 className="sneakpeakText">
          Hier een kleine sneakpeak van ons nieuwe project...
        </h1>

        <div className="screenshotContentBox">
          <img src={demofoto1} className="screenshotImage" alt="" />
          <img src={demofoto4} className="screenshotImage" alt="" />
          <img src={SafeBite1} className="screenshotImage" alt="" />
          <img src={SafeBite2} className="screenshotImage" alt="" />
        </div>
      </div>
    </div>
  );
}

export default ScreenshotsSection;
